import React, { useState } from 'react';
import { Button, Input } from 'antd';
import Swal from 'sweetalert2';
import { useNavigate } from 'react-router-dom';
import axiosInstance from '../utils/axiosInstance';
import { useTranslation } from 'react-i18next';
import AppShell from '../Components/AppShell';
import PageHeader from '../Components/PageHeader';
import Container from '../Components/Container';

const PasswordPage: React.FC = () => {
    const [loginButton, setLoginButton] = useState(true);
    const [currentPassword, setCurrentPassword] = useState("");
    const [newPassword, setNewPassword] = useState("");
    const [newPasswordCheck, setNewPasswordCheck] = useState("");

    const navigate = useNavigate();
    const { t } = useTranslation();

    const changePassword = async () => {
        if (!currentPassword || !newPassword) {
            return;
        }

        if (newPassword !== newPasswordCheck) {
            Swal.fire({
                title: 'Error!',
                text: 'New Password must be the same',
                icon: 'error',
            })
            return;
        }

        try {
            const res = await axiosInstance.post("/protected/changePassword", {
                currentPassword: currentPassword,
                newPassword: newPassword,
                isLoginPassword: loginButton,
            })
            if (res.status === 201) {
                // completed
                Swal.fire({
                    title: 'Success!',
                    text: 'Saved successfully',
                    icon: 'success',
                }).then(e => {
                    setCurrentPassword("");
                    setNewPassword("");
                    setNewPasswordCheck("");
                })
            } else {
                Swal.fire({
                    title: 'Error!',
                    text: 'Unable to update password',
                    icon: 'error',
                })
            }
        } catch {

        }
    }

    return (
        <AppShell
            header={<PageHeader title={t("password")} onBack={() => navigate(-1)} />}
        >
            <Container>
                {/* Deliberately narrow at lg: a full-width password form is worse, not
                    better, than a capped one — line length and focus matter more than
                    filling the monitor. Width is unchanged from mobile. */}
                <div className='p-6 flex flex-col gap-2 lg:max-w-[480px] lg:mx-auto lg:py-16'>
                    <div className='flex gap-2'>
                        <Button
                            onClick={() => setLoginButton(true)}
                            className={'text-[12px] text-white m-auto ' + (loginButton ? "bg-brand-800" : "bg-[rosybrown]")}
                            size='large' type="primary" htmlType="submit">
                            {t("login_password")}
                        </Button>
                        <Button
                            onClick={() => setLoginButton(false)}
                            className={'text-[12px] text-white m-auto ' + (!loginButton ? "bg-brand-800" : "bg-[rosybrown]")}
                            size='large' type="primary" htmlType="submit">
                            {t("withdrawal_password")}
                        </Button>
                    </div>
                    <div className='flex bg-white rounded-md border-2 border-solid text-[16px]'>
                        <p className='px-[11px] py-[4px] m-auto min-w-fit text-[14px]'>{t("current_password")}</p>
                        <Input
                            value={currentPassword}
                            className='text-right' type="password" size="large" placeholder={t("type_here")} variant="borderless"
                            onChange={(e) => setCurrentPassword(e.target.value)}
                        />
                    </div>
                    <div className='flex bg-white rounded-md border-2 border-solid text-[16px]'>
                        <p className='px-[11px] py-[4px] m-auto min-w-fit text-[14px]'>{t("new_password")}</p>
                        <Input
                            value={newPassword}
                            className='text-right' type="password" size="large" placeholder={t("type_here")} variant="borderless"
                            onChange={(e) => setNewPassword(e.target.value)}
                        />
                    </div>
                    <div className='flex bg-white rounded-md border-2 border-solid text-[16px]'>
                        <p className='px-[11px] py-[4px] m-auto min-w-fit text-[14px]'>{t("confirm_password")}</p>
                        <Input
                            value={newPasswordCheck}
                            className='text-right' type="password" size="large" placeholder={t("type_here")} variant="borderless"
                            onChange={(e) => setNewPasswordCheck(e.target.value)}
                        />
                    </div>

                    <div className='w-full flex mt-4'>
                        <Button
                            className='w-[80%] text-white m-auto bg-brand-800'
                            size='large' type="primary"
                            onClick={() => {
                                changePassword();
                            }}>
                            {t("confirm")}
                        </Button>
                    </div>
                </div>
            </Container>
        </AppShell>
    );
}

export default PasswordPage;